import React from 'react';
import SwipeableTemporaryDrawer from './Drawable';

const Layout = ({children}) => {
    return (
        <div>
            <SwipeableTemporaryDrawer/>
            <div className="mt-3" style={{ width: '95%', margin:'auto' }}>
                {children}
            </div>
        </div>
    )
}

export default Layout;
